import http from '../_http'

const userWmds = {
  //default
  summaryUser: (m) => { return http.get(`manager/wmds/user`, m); },
  listUser: (m) => { return http.post(`manager/wmds/user/list`, m); },
  detailUser: (m) => { return http.get(`manager/wmds/user/${m.id}`); },

  //crud
  insertUser: (m) => { return http.post(`manager/wmds/user`, m); },
  updateUser: (m) => { return http.put(`manager/wmds/user`, m); },
  deleteUser: (m) => { return http.delete(`manager/wmds/user/${m.id}`); },
}

export default userWmds

export { userWmds }